// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-care-coordinator-form .content-container{min-height:140px}.care-coordinator{padding-top:10px}.care-coordinator .care-coordinator__edit-btn{display:none}.care-coordinator:hover .care-coordinator__edit-btn{display:flex}", ""]);
// Exports
module.exports = exports;
